import { DEFAULT_PRACTICE_TYPE } from '@packages/practice-config';
const DIALECTS = {
    ATTORNEY: 'en',
    ADVOCATE: 'en',
    BUSINESS: 'en-x-business',
    // An administered entity's books carry no legal-practice vocabulary - no
    // matters, no fees heading - so the business dialect fits every kind, even
    // though "business's books" is itself an imperfect fit for an estate.
    BUSINESS_RESCUE: 'en-x-business',
    INSOLVENCY: 'en-x-business',
    ESTATE_ADMINISTRATION: 'en-x-business',
};
/** Resolve the copy locale for an account's practice type (null = legacy rows -> default). */
export function resolveLocale(practiceType) {
    return DIALECTS[practiceType ?? DEFAULT_PRACTICE_TYPE];
}
